import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ThemeProvider, createTheme } from '@mui/material';
import { MsalProvider, AuthenticatedTemplate, UnauthenticatedTemplate } from '@azure/msal-react';
import CssBaseline from '@mui/material/CssBaseline';
import Layout from './components/Layout/Layout';
import Dashboard from './pages/Dashboard';
import Login from './pages/Login';
import Contacts from './pages/Contacts';
import ContactForm from './pages/Contact';
import Companies from './pages/Companies';
import Company from './pages/Company';
import AuthWrapper from './components/AuthWrapper';
import MsalEventHandler from './components/MsalEventHandler';
import Opportunities from './pages/Opportunities';
import Opportunity from './pages/Opportunity';
import TimeTracker from './pages/TimeTracker';
import SupportContracts from './pages/SupportContracts';
import SupportContract from './pages/SupportContract';
import Talents from './pages/Talents';
import Talent from './pages/Talent';
import Admin from './pages/Admin';

import { msalInstance } from './services/authService';

// Create a theme instance
const theme = createTheme({
  palette: {
    primary: {
      main: '#2196f3',
    },
    secondary: {
      main: '#ff9800',
    },
    background: {
      default: '#f5f5f5',
    },
  },
});

function App() {
  return (
    <MsalProvider instance={msalInstance}>
      <MsalEventHandler />
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <Router>
          <AuthWrapper>
            <UnauthenticatedTemplate>
              <Routes>
                <Route path="*" element={<Login />} />
              </Routes>
            </UnauthenticatedTemplate>
            
            <AuthenticatedTemplate>
              <Layout>
                <Routes>
                  <Route path="/" element={<Dashboard />} />
                  <Route path="/opportunities" element={<Opportunities />} />
                  <Route path="/opportunities/new" element={<Opportunity />} />
                  <Route path="/opportunities/:id" element={<Opportunity />} />
                  <Route path="/companies" element={<Companies />} />
                  <Route path="/company/:companyId" element={<Company />} />
                  <Route path="/contacts" element={<Contacts />} />
                                    <Route path="/contact/:contactId" element={<ContactForm />} />
                  <Route path="/login" element={<Navigate to="/" replace />} />
                  <Route path="/time-tracker" element={<TimeTracker />} />
                  <Route path="/support-contracts" element={<SupportContracts />} />
                  <Route path="/support-contract/:contractId" element={<SupportContract />} />
                  <Route path="/talents" element={<Talents />} />
                  <Route path="/talent/:talentId" element={<Talent />} />
                  <Route path="/admin" element={<Admin />} />
                  <Route path="*" element={<Navigate to="/" replace />} />
                </Routes>
              </Layout>
            </AuthenticatedTemplate>
          </AuthWrapper>
        </Router>
      </ThemeProvider>
    </MsalProvider>
  );
}

export default App; 